module.exports = __webpack_public_path__ + "static/media/recpie1.2b284f62.png";